import React from 'react'
import FlexRow from '../components/containers/FlexRow'
import styled from 'styled-components'

const Thanks = () => {
  return (
    <FlexRow>
        <Students>
            <h3>Remerciements</h3>
            <p>Merci aux étudiants présents lors de notre sortie et à notre enseignante qui a joué le jeu et participé à toutes les activités.</p>
            <p>Merci à Maxime d'avoir développé le site.</p>
            <p>Merci à vous, d'avoir visité le site.</p>
        </Students>
        <Maxime>
            <h3>Mot de fin</h3>
            <p>Je m'appelle Maxime Jenn, j'ai 24 ans et je suis récemment diplômé en ingénierie informatique. Passionné d'informatique depuis toujours, je travaille aujourd'hui comme consultant en développement logiciel, notamment sur une solution qui accompagne des techniques d’analyses médicales.</p>
            <p>Ce site web a été conçu à la suite d’un challenge lancé, et en collaboration avec un groupe d’étudiants en urbanisme, un domaine qui, je l’avoue, ne m’était pas familier, mais que j’ai eu plaisir à découvrir à travers ce projet.</p> 
            <p>Le site a été réalisé en React.JS, en un peu plus de 7 heures, de zéro, dans une ambiance intense, stimulante et parfois un peu improvisée. Le résultat peut ou ne peut pas représenter l'étendue de mon travail habituel (Schrödinger), mais il représente un bel aperçu de ce que je peux faire dans un temps limité.</p>
            <p>Si j’avais eu davantage de temps, j’aurais aimé rendre ce site traduisible, responsif (c’est-à-dire adapté à tous les types d’écrans, que ce soit mobile, tablette ou ordinateur), et accessible à tous les profils d’utilisateurs, notamment ceux en situation de handicap.</p>
            <p>Ce projet m’a permis de repousser mes limites et de réaliser concrètement ce dont je suis capable en peu de temps. Et au final, je suis plûtot fier du résultat.</p>
            <p>Merci aux étudiants pour leur confiance et cette opportunité unique de sortir de ma zone de confort.<br/>— Maxime</p>
        </Maxime>
    </FlexRow>
  )
}

const BaseContainer = styled.div`
  font-weight: 500;
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  height: 100%;

  flex: 1;
  >p {
    margin: 10px 0px;
  }
`

const Maxime = styled(BaseContainer)`
  background-image: url(./imgs/Bg_galaxy.png);
  color: var(--content-primary-reverse);
`

const Students = styled(BaseContainer)`
  color: var(--content-accent-bis);
`

export default Thanks